module.exports = __webpack_public_path__ + "lk.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/lk.svg
// module id = 661
// module chunks = 0